<div class="container-fluid d-flex flex-column align-items-center justify-content-center m-0 p-0">
    <div class="background d-flex align-items-center justify-content-center m-0 p-0 py-5 w-100 h-100"
        style="background-image: url({{sliderhomeDesktop}}); position: relative;">
        <div class="overlay w-100 h-100"></div>

        <div class="col-md-10 col-12 d-flex flex-column align-items-center content busca my-4"
            style="z-index: 2; position: relative;">

            <h2 class="text-white text-center mb-md-5" style="font-size: 30px;">{{ frasehome | translate }}</h2>

            <div class="col-12 col-md-8 d-flex justify-content-center">
                <div class="col-12 mb-md-5">
                    <div class="btn-group d-flex flex-wrap justify-content-between" role="group"
                        aria-label="Basic checkbox toggle button group">

                        <div *ngIf="usaCircuito" class="col-md-2 col-4 d-flex flex-column align-items-center">
                            <input type="checkbox" class="btn-check" id="btnCircuito" autocomplete="off"
                                [(ngModel)]="busca.tipoBusca.circuito" [checked]="busca.tipoBusca.circuito"
                                (click)="marcarCircuito()">
                            <label
                                class=" rounded-circle d-flex justify-content-center align-items-center {{busca.tipoBusca.circuito ? 'bg-primary' : 'bg-outline-primary'}}"
                                for="btnCircuito" style="height: 100px; width: 100px;">
                                <i class="fas fa-globe text-white" style="font-size: larger;"></i>
                            </label>
                            <h6 class="text-white text-center mt-3">{{'Circuitos' | translate}}</h6>
                        </div>

                        <div class="col-md-2 col-4 d-flex flex-column align-items-center" *ngIf="usaAereo">
                            <input type="checkbox" class="btn-check" id="btnPlane" autocomplete="off"
                                [(ngModel)]="busca.tipoBusca.aereo" (ngModelChange)="tirouAereo()"
                                [checked]="busca.tipoBusca.aereo" (click)="naoCircuito()">
                            <label
                                class="rounded-circle d-flex justify-content-center align-items-center {{busca.tipoBusca.aereo ? 'bg-primary' : 'bg-outline-primary'}}"
                                for="btnPlane" style="height: 100px; width: 100px;">
                                <i class="fas fa-plane-departure text-white" style="font-size: larger;"></i>
                            </label>
                            <h6 class="text-white text-center mt-3">{{'Aéreo' | translate}}</h6>
                        </div>

                        <div class="col-md-2 col-4 d-flex flex-column align-items-center">
                            <input type="checkbox" class="btn-check" id="btnHotel" autocomplete="off"
                                [(ngModel)]="busca.tipoBusca.hotel" [checked]="busca.tipoBusca.hotel"
                                (click)="naoCircuito()">
                            <label
                                class=" rounded-circle d-flex justify-content-center align-items-center {{busca.tipoBusca.hotel ? 'bg-primary' : 'bg-outline-primary'}}"
                                for="btnHotel" style="height: 100px; width: 100px;">
                                <i class="fas fa-bed text-white" style="font-size: larger;"></i>
                            </label>
                            <h6 class="text-white text-center mt-3">{{'Hotel' | translate}}</h6>
                        </div>

                        <div class="col-md-2 col-4 d-flex flex-column align-items-center">
                            <input type="checkbox" class="btn-check" id="btnServico" autocomplete="off"
                                [(ngModel)]="busca.tipoBusca.ticket" [checked]="busca.tipoBusca.ticket"
                                (click)="naoCircuito()">
                            <label
                                class=" rounded-circle d-flex justify-content-center align-items-center {{busca.tipoBusca.ticket ? 'bg-primary' : 'bg-outline-primary'}}"
                                for="btnServico" style="height: 100px; width: 100px;">
                                <i class="fas fa-shuttle-van text-white" style="font-size: larger;"></i>
                            </label>
                            <h6 class="text-white text-center mt-3">
                                {{projeto !== "DELIVERY" ? ('Serviço' | translate) : ('Serviços Brasil' | translate)}}
                            </h6>
                        </div>

                        <div class="col-md-2 col-4 d-flex flex-column align-items-center" *ngIf="usaCarro">
                            <input type="checkbox" class="btn-check" id="btnCarro" autocomplete="off"
                                [(ngModel)]="busca.tipoBusca.carro" [checked]="busca.tipoBusca.carro"
                                (click)="naoCircuito()">
                            <label
                                class=" rounded-circle d-flex justify-content-center align-items-center {{busca.tipoBusca.carro ? 'bg-primary' : 'bg-outline-primary'}}"
                                for="btnCarro" style="height: 100px; width: 100px;">
                                <i class="fas fa-car text-white" style="font-size: larger;"></i>
                            </label>
                            <h6 class="text-white text-center mt-3">{{'Carro' | translate}}</h6>
                        </div>

                        <div class="col-md-2 col-4 d-flex flex-column align-items-center" *ngIf="usaBetoCarrero">
                            <input type="checkbox" class="btn-check" id="btnBeto" autocomplete="off"
                                [(ngModel)]="busca.tipoBusca.beto" [checked]="busca.tipoBusca.beto"
                                (click)="naoCircuito()">
                            <label
                                (click)="playSound()"
                                class=" rounded-circle d-flex justify-content-center align-items-center {{busca.tipoBusca.beto ? 'bg-primary' : 'bg-outline-primary'}}"
                                for="btnBeto" style="height: 100px; width: 100px;">
                                <!-- <i class="fa fa-hat-cowboy-side text-white" style="font-size: larger;"></i> -->
                                <img src="assets/images/mmc/beto-carreiro-logo-png_seeklogo-257349.svg" style="width: 4rem;" />
                            </label>
                            <h6 class="text-white text-center mt-3">{{'Beto Carrero' | translate}}</h6>
                        </div>

                        <div class="col-md-2 col-4 d-flex flex-column align-items-center" *ngIf="usaCivitatis">
                            <input type="checkbox" class="btn-check" id="btnCivitatis" autocomplete="off"
                                [(ngModel)]="busca.tipoBusca.servicoExclusivo"
                                [checked]="busca.tipoBusca.servicoExclusivo" (click)="naoCircuito()">
                            <label
                                class=" rounded-circle d-flex justify-content-center align-items-center {{busca.tipoBusca.servicoExclusivo ? 'bg-primary' : 'bg-outline-primary'}}"
                                for="btnCivitatis" style="height: 100px; width: 100px;">
                                <i class="fa fa-paper-plane text-white" style="font-size: larger;"></i>
                            </label>
                            <h6 class="text-white text-center mt-3">
                                {{ projeto === "DELIVERY" ? ('Serviços Mundo' | translate) : ('Serviço Exclusivo' |
                                translate) }}
                            </h6>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                @if (!busca.tipoBusca.aereo &&
                !busca.tipoBusca.hotel &&
                !busca.tipoBusca.ticket &&
                !busca.tipoBusca.carro &&
                !busca.tipoBusca.beto &&
                !busca.tipoBusca.carro &&
                !busca.tipoBusca.servicoExclusivo &&
                !busca.tipoBusca.circuito
                ) {
                <div class="col-12 mt-4 d-flex justify-content-center align-items-center">
                    <div class="alert alert-danger" role="alert">
                        {{"Você precisa selecionar algum dos itens!" | translate}}
                    </div>
                </div>
                } @else if (
                busca.tipoBusca.aereo ||
                busca.tipoBusca.hotel ||
                busca.tipoBusca.ticket ||
                busca.tipoBusca.carro ||
                busca.tipoBusca.beto ||
                busca.tipoBusca.carro ||
                busca.tipoBusca.servicoExclusivo ||
                busca.tipoBusca.circuito
                ) {
                <div class="col-12 d-flex flex-column align-items-center justify-content-center box-shadow h-100 pb-3">
                    <div class="col-12 m-0 mt-3 d-flex" *ngIf="usaAereo && busca.tipoBusca.aereo">
                        <div class="mx-auto d-flex justify-content-between btn-group my-custom-group" role="role">
                            <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off"
                                (click)="tipoAereo(TIPOBUSCAAEREO.idaVolta)" [value]="TIPOBUSCAAEREO.idaVolta"
                                [checked]="busca.tipoBuscaAereo == TIPOBUSCAAEREO.idaVolta"
                                [disabled]="!busca.tipoBusca.aereo" />
                            <label class="btn p-2 px-4 fw-normal" for="btnradio1">{{'Ida e Volta' | translate}}</label>

                            <input *ngIf="usaAreoApenasIda" type="radio" class="btn-check" name="btnradio"
                                id="btnradio3" (click)="tipoAereo(TIPOBUSCAAEREO.ida)" [value]="TIPOBUSCAAEREO.ida"
                                [disabled]="!busca.tipoBusca.aereo"
                                [checked]="busca.tipoBuscaAereo == TIPOBUSCAAEREO.ida" />
                            <label *ngIf="usaAreoApenasIda" class="btn p-2 px-4 fw-normal" for="btnradio3">
                                {{'Somente Ida' | translate}}</label>

                            <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off"
                                (click)="tipoAereo(TIPOBUSCAAEREO.multiplosTrechos)"
                                [value]="TIPOBUSCAAEREO.multiplosTrechos"
                                [checked]="busca.tipoBuscaAereo == TIPOBUSCAAEREO.multiplosTrechos"
                                [disabled]="!busca.tipoBusca.aereo" />
                            <label class="btn p-2 px-4 fw-normal" for="btnradio2">
                                {{'Múltiplos Trechos' | translate}}</label>
                        </div>
                    </div>

                    <form #meuFormulario="ngForm" (ngSubmit)="validarFormulario()" class="col-12 row px-md-4">
                        @if (busca.tipoBusca.circuito) {
                        <section class="circuitoActive row d-flex flex-row align-items-center mt-3">
                            <div class="col-12">
                                <div class="col-12 d-flex flex-row">
                                    <div class="col-3 d-flex flex-column">
                                        <label class="mb-1" style="color: #808080;">Temporada</label>
                                        <select [(ngModel)]="Temporada" class="form-control pb-3 pt-3"
                                            style="margin-right: 15px;" name="inputTemporada">
                                            <option *ngFor="let temporada of Temporadas" [value]="temporada">
                                                {{temporada +" - "+ addOneYear(temporada)}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 d-flex flex-row mt-2 pt-1">
                                        <div class="d-flex form-control justify-content-center mt-3 pt-2 pb-2"
                                            style="margin-left: 15px; margin-right: 15px;"
                                            *ngFor="let circuitoFornecedor of Fornecedores; let i = index;">
                                            <div class="align-self-center text-center">
                                                <input type="checkbox" style="width: 21px; height: 21px;"
                                                    id="circuito-{{circuitoFornecedor}}"
                                                    name="circuito-{{circuitoFornecedor}}"
                                                    (change)="selecionarCircuito(circuitoFornecedor)"
                                                    [checked]="circuitoSelecionado(circuitoFornecedor)" />
                                            </div>
                                            <div class="d-flex align-self-center" style="margin-left: 15px;">
                                                <label class="form-check-label" for="circuito-{{circuitoFornecedor}}">
                                                    <img style="width: 200px; max-height: 200px; min-height: 0px !important;"
                                                        src="assets/img/circuitos/{{circuitoFornecedor}}.png" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between mt-3">
                                    <button type="reset" class="btn btn-outline-primary" *ngIf="!adicionar"
                                        (click)="setUmTrecho(); limpaPesquisa()">
                                        {{"Limpar Busca" | translate}}
                                    </button>
                                    <button type="submit" class="btn btn-primary"
                                        *ngIf="busca.tipoBusca.circuito" (click)="validarFormulario()">
                                        <!-- [disabled]="usuario.EmpresaId == null" -->
                                        {{"Buscar" | translate}}
                                    </button>
                                </div>
                            </div>
                        </section>
                        }
                        @if (busca.tipoBusca.aereo) {
                        <section class="aereoActive col-12 d-flex flex-column align-items-center py-1 mt-3">
                            <div class="col-12 ">
                                <div class="col-12 d-flex flex-column align-items-center trechos"
                                    *ngFor="let trecho of busca.trechos; let i = index; trackBy: trackByIndex">
                                    <div *ngIf="busca.tipoBuscaAereo === 'multiplos-trechos' && busca.tipoBusca.aereo"
                                        class="{{ busca.tipoBuscaAereo === 'multiplos-trechos' ? 'col-12 mb-1 mt-2' : '' }}">
                                        <h6 class="m-0">{{"Trecho" | translate}} {{i +1}}</h6>
                                    </div>

                                    <div class="col-12 d-flex align-items-center justify-content-center">
                                        <div
                                            class="col-12 row d-flex gap-3 align-items-center {{busca.tipoBuscaAereo === 'multiplos-trechos' ? 'justify-content-center' : ''}}">
                                            <!-- Campo de Aeroporto de Partida -->
                                            <div class=" col-12 col-md">
                                                <app-typeahead class="form-floating typea d-block" [tap]="false"
                                                    [lista]="cidades"
                                                    [searchText]="trecho.AeroportoPartida.display_field"
                                                    (searchFunction)="buscaDados($event)"
                                                    (selectItem)="selecionaCidadeOrigem($event, trecho)">
                                                    <input class="form-control" type="text"
                                                        placeholder="{{'Aeroporto de Partida' | translate}}"
                                                        [(ngModel)]="trecho.AeroportoPartida.display_field"
                                                        (ngModelChange)="buscaCidadeDebounce($event)" autocomplete="off"
                                                        required name="cidadepartida-{{i}}" />
                                                    <label for="floatingInput">{{"Origem" | translate}}</label>
                                                </app-typeahead>
                                                <div *ngIf="meuFormulario.controls['cidadepartida-' + i]?.invalid && meuFormulario.controls['cidadepartida-' + i]?.touched"
                                                    class="text-danger">
                                                    Campo de origem é obrigatório.
                                                </div>
                                            </div>
                                            <!-- Campo de Aeroporto de Chegada -->
                                            <div class="form-floating col-12 col-md ">
                                                <app-typeahead class="form-floating d-block" [lista]="cidades"
                                                    [searchText]="trecho.AeroportoChegada.display_field"
                                                    (searchFunction)="buscaDados($event)"
                                                    (selectItem)="selecionaCidadeDestino($event, trecho)">
                                                    <input class="form-control" type="text"
                                                        placeholder="{{'Aeroporto de Chegada' | translate}}"
                                                        [(ngModel)]="trecho.AeroportoChegada.display_field"
                                                        (ngModelChange)="buscaCidadeDebounce($event)" autocomplete="off"
                                                        required name="cidadechegada-{{i}}" />
                                                    <label for="floatingInput">{{"Destino" | translate}}</label>
                                                </app-typeahead>
                                                <div *ngIf="meuFormulario.controls['cidadechegada-' + i]?.invalid && meuFormulario.controls['cidadechegada-' + i]?.touched"
                                                    class="text-danger">
                                                    Campo de destino é obrigatório.
                                                </div>
                                            </div>

                                            <!-- Campo Data de Ida -->
                                            <div class="form-datepicker col-12 col-md">
                                                <mat-form-field class="datepicker" appearance="fill">
                                                    <mat-label>{{ (busca.tipoBusca.aereo) ? "Data de Ida" : "Check-in" |
                                                        translate }}</mat-label>

                                                    <input matInput [(ngModel)]="trecho.dataIda" name="dataIda{{i}}"
                                                        [matDatepicker]="pickers[i]"
                                                        (keypress)="permitirSomenteDatas($event)"
                                                        (input)="formatarDataManual($event)" (keydown)="limpar($event)"
                                                        (blur)="validarDataFinal($event)"
                                                        (dateChange)="setDataIda($event, busca.trechos, i)"
                                                        [min]="trecho.minDataIda" maxlength="10" required />

                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="pickers[i]"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                    <!-- esta linha é CLONADA por *ngFor -->
                                                </mat-form-field>
                                                <div *ngIf="meuFormulario.controls['dataIda']?.invalid && meuFormulario.controls['dataIda']?.touched"
                                                    class="text-danger">
                                                    Data de Ida é obrigatória.
                                                </div>
                                            </div>

                                            <!-- Campo Data de Volta -->
                                            <div class="form-datepicker col-12 col-md"
                                                *ngIf="busca.tipoBuscaAereo =='ida-volta'">
                                                <mat-form-field class="datepicker" appearance="fill">
                                                    <mat-label class="label-datepicker">{{(busca.tipoBusca.aereo ) ?
                                                        "Data de Volta" : "Check-out" | translate }}</mat-label>
                                                    <input matInput [matDatepicker]="pickerVolta"
                                                        [(ngModel)]="trecho.dataVolta" name="dataVolta"
                                                        (dateChange)="setDataVolta($event, busca.trechos, i)"
                                                        [min]="trecho.minDataVolta" id="dataVolta"
                                                        (keypress)="permitirSomenteDatas($event)"
                                                        (input)="formatarDataManual($event)" (keydown)="limpar($event)"
                                                        maxlength="10" required />
                                                    <!-- <mat-hint>DD/MM/AAAA</mat-hint> -->
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="pickerVolta"></mat-datepicker-toggle>
                                                    <mat-datepicker #pickerVolta disabled="false"></mat-datepicker>
                                                </mat-form-field>
                                                <div *ngIf="meuFormulario.controls['dataVolta']?.invalid && meuFormulario.controls['dataVolta']?.touched"
                                                    class="text-danger">
                                                    Data de Volta é obrigatória.
                                                </div>
                                            </div>

                                            <div class="col-md-1 d-flex flex-column align-items-center ms-auto"
                                                *ngIf="busca.tipoBuscaAereo == 'multiplos-trechos' && i < busca.trechos.length - 1 && !(i < 1)">
                                                <i class="fas fa-minus-circle text-primary fs-5" style="cursor: pointer"
                                                    (click)="removerTrecho(i)"></i>
                                            </div>
                                            <div class="col-md-1 d-flex flex-column align-item-center ms-auto"
                                                *ngIf="busca.tipoBuscaAereo == 'multiplos-trechos' && (i < 1)">
                                            </div>

                                            <div class="col-md-1 d-flex flex-column align-items-center ms-auto"
                                                *ngIf="busca.tipoBuscaAereo == 'multiplos-trechos' && busca.trechos.length < 5 && i == busca.trechos.length - 1">
                                                <i class="fas fa-plus-circle fs-5" (click)="setUmTrecho()"
                                                    style="cursor: pointer"></i>
                                            </div>
                                            <div *ngIf="busca.tipoBuscaAereo == 'multiplos-trechos' && busca.trechos.length == 5 && i == busca.trechos.length - 1"
                                                class="col-md-1 d-flex flex-column align-items-center ms-auto">
                                                <h5 style="margin: 0">Max</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 d-flex justify-content-center mt-3"
                                        *ngIf="busca.tipoBusca.beto">
                                        <!-- Campo Data de Visita -->
                                        <div class="form-datepicker col-12 col-md-6">
                                            <mat-form-field class="datepicker" appearance="fill">
                                                <mat-label class="label-datepicker">{{"Data de visita" | translate }}
                                                    (Beto Carrero)</mat-label>
                                                <input matInput [matDatepicker]="pickerVisita"
                                                    [(ngModel)]="busca.dataVisitaBetoCarrero" name="visita" id="visita"
                                                    [min]="getMinDataVisita(trecho)" [max]="trecho.dataVolta"
                                                    (keypress)="permitirSomenteDatas($event)"
                                                    (input)="formatarDataManual($event)" (keydown)="limpar($event)"
                                                    maxlength="10" required />
                                                <!-- <mat-hint>DD/MM/AAAA</mat-hint> -->
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="pickerVisita"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerVisita></mat-datepicker>
                                            </mat-form-field>
                                            <div *ngIf="meuFormulario.controls['visita']?.invalid && meuFormulario.controls['visita']?.touched"
                                                class="text-danger">
                                                Data de Visita é obrigatória.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 row d-flex flex-column-reverse flex-md-row align-items-md-end mt-3">
                                <div class="col-12 col-md-8 mt-3 mb-1">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="bagagem" name="vooBagagem"
                                            [(ngModel)]="busca.opcoesAvancadas.TodasFamilias">
                                        <label class="form-check-label" for="bagagem">
                                            {{"Somente voos com bagagem" | translate}}
                                        </label>
                                    </div>

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="voo_direto" name="vooDireto"
                                            [(ngModel)]="busca.opcoesAvancadas.diretos">
                                        <label class="form-check-label" for="voo_direto">
                                            {{"Voo Direto" | translate}}
                                        </label>
                                    </div>

                                    <div class="col-12 d-flex flex-md-row flex-column mt-2"
                                        *ngIf="busca.ReservaId === 0">
                                        <div class="mt-auto">
                                            <button type="button" class="btn btn-outline-primary"
                                                (click)="abrirModal(modalQuartos)">
                                                {{busca.getQtdeAdultos() + busca.getQtdeChd()}} {{"Passageiro(s)" |
                                                translate}} /
                                                {{busca.getQtdeQuartos()}} {{"Quarto(s)" | translate}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="form-floating col-12 col-md-4 mt-4 mt-md-0 {{ busca.tipoBuscaAereo === 'ida-volta' ? '' : '' }}">
                                    <app-typeahead class="form-floating d-block" name="cidadepartida" [lista]="paises"
                                        [searchText]="busca.nacionalidadePax.Nome" (searchFunction)="buscaPais($event)"
                                        (selectItem)="selecionaPaisNacionalidade($event)">
                                        <input class="form-control" type="text" placeholder="Nacionalidade do pax"
                                            [(ngModel)]="busca.nacionalidadePax.Nome"
                                            (ngModelChange)="buscaPaisDebounce($event)" autocomplete="off"
                                            name="paisNacionalidade" required />
                                        <label for="floatingInput">{{"Nacionalidade" | translate}}</label>
                                    </app-typeahead>
                                    <div *ngIf="meuFormulario.controls['paisNacionalidade']?.invalid && meuFormulario.controls['paisNacionalidade']?.touched"
                                        class="text-danger">
                                        Nacionalidade do pax é obrigatória.
                                    </div>
                                </div>
                            </div>

                            <div class="col-10">
                                <hr>

                                <div class="d-flex justify-content-between">
                                    <button type="reset" class="btn btn-outline-primary" *ngIf="busca.ReservaId === 0"
                                        (click)="limpaPesquisa()">{{"Limpar Busca" | translate}}</button>
                                    <button type="submit" class="btn btn-primary"
                                        *ngIf="busca.tipoBusca.aereo || busca.tipoBusca.hotel || busca.tipoBusca.ticket || busca.tipoBusca.carro || busca.tipoBusca.servicoExclusivo"
                                        [disabled]="((!busca.tipoBusca.hotel && !busca.tipoBusca.ticket) && busca.usuario.EmpresaId == null) && !permiteAgenciaBuscarSomenteAereo">
                                        {{"Buscar" | translate}}
                                    </button>
                                </div>
                            </div>
                        </section>
                        } @else if (!busca.tipoBusca.aereo && (busca.tipoBusca.hotel || busca.tipoBusca.ticket ||
                        busca.tipoBusca.servicoExclusivo)) {
                        <section class="hotelOrServiceActive col-12 row py-1 mt-3">
                            <div class="col-12 row trechos p-0" *ngFor="let trecho of busca.trechos; let i = index">
                                <div class="col-12 row gap-2 gap-md-0 row">
                                    <div class="col-12 row d-flex justify-content-start flex-column flex-md-row ml-0">
                                        <div class="form-floating col-12 col-md-3"
                                            [ngClass]="{'col-md-4' : !busca.tipoBusca.beto}">
                                            <app-typeahead class="form-floating d-block" [tap]="true"
                                                name="cidadechegada" [lista]="cidades"
                                                [searchText]="trecho.cidadeDestino.display_field"
                                                (searchFunction)="buscaDados($event)"
                                                (selectItem)="selecionaCidadeDestino($event, trecho)">
                                                <input class="form-control" type="text"
                                                    placeholder="{{'Cidade de Destino' | translate}}"
                                                    [(ngModel)]="trecho.cidadeDestino.display_field"
                                                    name="cidadeDestino" required #inputDestino="ngModel"
                                                    (ngModelChange)="buscaCidadeDebounce($event)" autocomplete="off"
                                                    (keydown.enter)="$event.preventDefault()" />
                                                <label for="floatingInput">{{"Cidade" | translate}}</label>
                                            </app-typeahead>
                                            <div *ngIf="inputDestino.invalid && inputDestino.touched"
                                                class="text-danger">
                                                Escolher a cidade é obrigatório.
                                            </div>
                                        </div>

                                        <!-- Campo Data de Ida -->
                                        <div class="form-datepicker col-12 col-md-3 px-1"
                                            [ngClass]="{'col-md-4' : !busca.tipoBusca.beto}">
                                            <mat-form-field class="datepicker" appearance="fill">
                                                <mat-label class="label-datepicker">{{"Data de Ida" | translate
                                                    }}</mat-label>
                                                <input matInput [matDatepicker]="dataCheckin"
                                                    [(ngModel)]="trecho.dataIda" name="dataIda"
                                                    (dateChange)="setDataIda($event, busca.trechos, i)"
                                                    [min]="trecho.minDataIda" id="dataIda"
                                                    (keypress)="permitirSomenteDatas($event)"
                                                    (input)="formatarDataManual($event)" (keydown)="limpar($event)"
                                                    maxlength="10" autocomplete="off" required />
                                                <!-- <mat-hint>DD/MM/AAAA</mat-hint> -->
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="dataCheckin"></mat-datepicker-toggle>
                                                <mat-datepicker #dataCheckin></mat-datepicker>
                                            </mat-form-field>
                                            <div *ngIf="meuFormulario.controls['dataIda']?.invalid && meuFormulario.controls['dataIda']?.touched"
                                                class="text-danger">
                                                Data de Ida é obrigatória.
                                            </div>
                                        </div>

                                        <!-- Campo Data de Volta -->
                                        <div class="form-datepicker col-12 col-md-3 px-1"
                                            [ngClass]="{'col-md-4' : !busca.tipoBusca.beto}">
                                            <mat-form-field class="datepicker" appearance="fill">
                                                <mat-label class="label-datepicker">{{"Data de Volta" | translate
                                                    }}</mat-label>
                                                <input matInput [matDatepicker]="pickerCheckout"
                                                    [(ngModel)]="trecho.dataVolta" name="dataVolta"
                                                    (dateChange)="setDataVolta($event, busca.trechos, i)"
                                                    [min]="trecho.minDataVolta" id="inputVolta"
                                                    (keypress)="permitirSomenteDatas($event)"
                                                    (input)="formatarDataManual($event)" (keydown)="limpar($event)"
                                                    maxlength="10" required autocomplete="off" />
                                                <!-- <mat-hint>DD/MM/AAAA</mat-hint> -->
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="pickerCheckout"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerCheckout></mat-datepicker>
                                            </mat-form-field>
                                            <div *ngIf="meuFormulario.controls['inputVolta']?.invalid && meuFormulario.controls['inputVolta']?.touched"
                                                class="text-danger">
                                                Data de Volta é obrigatória.
                                            </div>
                                        </div>

                                        <!-- Campo Data de Visita (Beto Carrero) -->
                                        <div class="form-datepicker col-12 col-md-3 px-1" *ngIf="busca.tipoBusca.beto">
                                            <mat-form-field class="datepicker" appearance="fill">
                                                <mat-label class="label-datepicker">{{"Data de visita" | translate }}
                                                    (Beto Carrero)</mat-label>
                                                <input matInput [matDatepicker]="pickerVisita"
                                                    [(ngModel)]="busca.dataVisitaBetoCarrero" name="visita" id="visita"
                                                    [min]="busca.trechos[0].dataIda"
                                                    [max]="busca.trechos[busca.trechos.length -1].dataVolta"
                                                    (keypress)="permitirSomenteDatas($event)"
                                                    (input)="formatarDataManual($event)" (keydown)="limpar($event)"
                                                    maxlength="10" required />
                                                <!-- <mat-hint>DD/MM/AAAA</mat-hint> -->
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="pickerVisita"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerVisita></mat-datepicker>
                                            </mat-form-field>
                                            <div *ngIf="meuFormulario.controls['visita']?.invalid && meuFormulario.controls['visita']?.touched"
                                                class="text-danger">
                                                Data de Visita é obrigatória.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 row d-flex flex-column-reverse flex-md-row align-items-md-end mt-3">
                                <div class=" col-12 col-md-8 mt-3 mb-1">
                                    <div class="d-flex gap-3 div_pbv mob-wrap">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="checkbox" id="promocoes"
                                                name="inputPromocao">
                                            <label class="form-check-label" for="promocoes">
                                                {{"Apenas Promoções" | translate}}
                                            </label>
                                        </div>

                                    </div>

                                    <div class="col-12 d-flex mt-2" *ngIf="busca.ReservaId === 0">
                                        <div class="d-grid gap-3">
                                            <button type="button" class="btn btn-outline-primary"
                                                (click)="abrirModal(modalQuartos)">
                                                {{busca.getQtdeAdultos() + busca.getQtdeChd()}}{{" Passageiro(s) / " |
                                                translate}}
                                                {{busca.getQtdeQuartos()}}{{" Quarto(s)" | translate}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-floating col-12 col-md-4 mt-4 mt-md-0">
                                    <app-typeahead class="form-floating d-block" name="cidadepartida" [lista]="paises"
                                        [searchText]="busca.nacionalidadePax.Nome" (searchFunction)="buscaPais($event)"
                                        (selectItem)="selecionaPaisNacionalidade($event)"
                                        (keydown.enter)="$event.preventDefault()">
                                        <input class="form-control" type="text" placeholder="Nacionalidade do pax"
                                            [(ngModel)]="busca.nacionalidadePax.Nome"
                                            (ngModelChange)="buscaPaisDebounce($event)" autocomplete="off"
                                            name="paisNacionalidade" required />
                                        <label for="floatingInput">{{"Nacionalidade" | translate}}</label>
                                    </app-typeahead>
                                    <div *ngIf="meuFormulario.controls['paisNacionalidade']?.invalid && meuFormulario.controls['paisNacionalidade']?.touched"
                                        class="text-danger">
                                        Nacionalidade do pax é obrigatória.
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 mx-auto">
                                <hr>

                                <div class="d-flex justify-content-between mb-4">
                                    <button type="reset" class="btn btn-outline-primary" *ngIf="busca.ReservaId === 0"
                                        (click)="setUmTrecho(); limpaPesquisa()">{{"Limpar Busca" | translate}}</button>
                                    <button type="submit" class="btn btn-primary" (keydown.enter)="validarFormulario()" (click)="validarFormulario()"
                                        *ngIf="busca.tipoBusca.aereo || busca.tipoBusca.hotel || busca.tipoBusca.ticket || busca.tipoBusca.carro || busca.tipoBusca.servicoExclusivo"
                                        [disabled]="((!busca.tipoBusca.hotel && !busca.tipoBusca.ticket) && busca.usuario.EmpresaId == null) && !permiteAgenciaBuscarSomenteAereo">
                                        {{"Buscar" | translate}}
                                    </button>
                                </div>
                            </div>
                        </section>
                        } @else if (this.busca.tipoBusca.beto) {
                        <section class="betoActive col-12 py-4"
                            *ngIf="!busca.tipoBusca.aereo && !busca.tipoBusca.hotel && !busca.tipoBusca.ticket && !busca.tipoBusca.carro && busca.tipoBusca.beto && !busca.tipoBusca.servicoExclusivo">
                            <div class="col-12 d-flex flex-column align-items-center">
                                <div class="d-flex justify-content-center col-4">
                                    <div class="form-datepicker no-hint col-12 col-md-12" *ngIf="busca.tipoBusca.beto">
                                        <mat-form-field class="datepicker" appearance="fill">
                                            <mat-label class="label-datepicker">{{"Data de visita" | translate }} (Beto
                                                Carrero)</mat-label>
                                            <input matInput [matDatepicker]="pickerVisita"
                                                [(ngModel)]="busca.dataVisitaBetoCarrero" name="dataVisitaBetoCarrero"
                                                id="visita" [min]="getHoje()" (keypress)="permitirSomenteDatas($event)"
                                                (input)="formatarDataManual($event)" (keydown)="limpar($event)"
                                                maxlength="10" required />
                                            <!-- <mat-hint>DD/MM/AAAA</mat-hint> -->
                                            <mat-datepicker-toggle matSuffix
                                                [for]="pickerVisita"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerVisita></mat-datepicker>
                                        </mat-form-field>
                                        <div *ngIf="meuFormulario.controls['visita']?.invalid && meuFormulario.controls['visita']?.touched"
                                            class="text-danger">
                                            Data de Visita é obrigatória.
                                        </div>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <hr>

                                    <div class="d-flex justify-content-between">
                                        <button type="reset" class="btn btn-outline-primary"
                                            *ngIf="busca.ReservaId === 0"
                                            (click)="setUmTrecho(); limpaPesquisa()">{{"Limpar Busca" |
                                            translate}}</button>
                                        <button type="button" class="btn btn-primary"
                                            (click)="buscar()"
                                            *ngIf="busca.tipoBusca.beto && !busca.tipoBusca.aereo && !busca.tipoBusca.hotel && !busca.tipoBusca.ticket && !busca.tipoBusca.carro"
                                            [disabled]="(!busca.tipoBusca.beto) && usuarioLogado.EmpresaId == null">
                                            {{"Buscar" | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                        }
                    </form>
                </div>
                }
            </div>
        </div>
    </div>

    @if (projeto == 'Brasil'){
    <div class="container-fluid row d-flex justify-content-center m-0 p-0 p-md-2"
        style="padding-left: 0 !important; padding-right:  0 !important;">
        <!-- primeiro carroussel -->
        <div class="col-12 row d-flex align-items-center justify-content-center p-0 p-md-2">
            <div class="col-12 col-md-10 d-flex align-items-center justify-content-center p-0 ps-md-4 my-5 text-center">
                <div class="text-center">
                    <h3 class="m-0">{{"Viajes en grupo con guía acompañante"| translate}}</h3>
                    <p class="m-1">Descubre Brasil de la mano de nuestros expertos en destino</p>
                </div>
            </div>

            <div class="col-12 d-flex justify-content-center p-0 p-md-2">
                <p-carousel class="col-12 p-0" *ngIf="pacotes && pacotes.length > 0" [value]="pacotes"
                    autoplayInterval="6000" [responsiveOptions]="responsiveOptions">
                    <ng-template pTemplate="item" let-pacote>
                        <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                            <div class="card-pacote border d-flex flex-column">
                                <img src="{{ pacote?.PacoteImagens.length > 0  ? pacote?.PacoteImagens[0].Imagem : backgroundimage}}"
                                    class="card-img-top">
                                <div class="card-body d-flex flex-column px-3 py-4">
                                    <div class="row">
                                        <div class="col">
                                            <h6 class="card-subtitle text-muted">{{ pacote.Cidade.Nome }}</h6>
                                        </div>
                                        <div class="col duration">
                                            <span class="duration">{{ pacote.MinimoDeNoites }}
                                                {{ "Noite" | translate }}(s)</span>
                                        </div>
                                    </div>
                                    <h5 class="card-title">
                                        {{ idioma == 'es' && pacote?.Nome_Es ? pacote?.Nome_Es :
                                        idioma == 'en' && pacote?.Nome_En ? pacote?.Nome_En :
                                        pacote?.Nome }}
                                    </h5>
                                    <div class="mt-auto card-bottom">
                                        <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal"
                                            data-bs-target="#detailsModal" (click)="PacoteDetalhes = pacote">
                                            {{"Detalhes do pacote" | translate}}
                                        </button>
                                        <button class="btn btn-search" type="button"
                                            (click)="abrirModalPacote(pacote, contentHotelDetalhes)">
                                            {{"Selecionar" | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-carousel>
            </div>

        </div>
        <div class="col-12 d-flex align-items-center justify-content-center m-0 p-0 " [ngStyle]="{
                'height': isMobile('h') ? '100%' : '37.5rem',
                'background-image': 'url(' + sliderhome + ')',
                'max-width': '100%',
                'min-height': '292px',
                'max-height': '80vh',
                'background-repeat': 'no-repeat',
                'background-size': isMobile('s') ? 'contain' : 'cover',
                'background-position': 'center'
              }">
        </div>

        <!-- Segundo Carroussel -->
        <div class="col-12 row d-flex align-items-center justify-content-center p-0 p-md-2"
            *ngIf="segundoCarrousselPacotes && segundoCarrousselPacotes.length > 0">
            <div class="col-12 col-md-10 d-flex align-items-center justify-content-center p-0 ps-md-4 my-5 text-center">
                <div class="text-center">
                    <h3 class="m-0">{{"Destinos Top Vendas"| translate}}</h3>
                    <p class="m-1">{{"Para a onde quer viajar" | translate}}?</p>
                </div>
            </div>

            <div class="col-12 d-flex justify-content-center p-0 p-md-2">
                <p-carousel class="col-12 p-0" [value]="segundoCarrousselPacotes" autoplayInterval="6000"
                    [responsiveOptions]="responsiveOptions">
                    <ng-template pTemplate="item" let-pacote>
                        <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                            <div class="card-pacote border d-flex flex-column">
                                <img src="{{ pacote?.PacoteImagens.length > 0  ? pacote?.PacoteImagens[0].Imagem : backgroundimage}}"
                                    class="card-img-top">
                                <div class="card-body d-flex flex-column px-3 py-4">
                                    <div class="row">
                                        <div class="col">
                                            <h6 class="card-subtitle text-muted">{{ pacote.Cidade.Nome }}</h6>
                                        </div>
                                        <div class="col duration">
                                            <span class="duration">{{ pacote.MinimoDeNoites }} {{ "Noite" | translate
                                                }}(s)</span>
                                        </div>
                                    </div>
                                    <h5 class="card-title">
                                        {{ idioma == 'es' && pacote?.Nome_Es ? pacote?.Nome_Es :
                                        idioma == 'en' && pacote?.Nome_En ? pacote?.Nome_En :
                                        pacote?.Nome }}
                                    </h5>
                                    <div class="mt-auto card-bottom">
                                        <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal"
                                            data-bs-target="#detailsModal" (click)="PacoteDetalhes = pacote">
                                            {{"Detalhes do pacote" | translate}}
                                        </button>
                                        <button class="btn btn-search" type="button"
                                            (click)="abrirModalPacote(pacote, contentHotelDetalhes)">
                                            {{"Selecionar" | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-carousel>
            </div>

        </div>
    </div>
    }
</div>

<ng-template let-modal #modalQuartos>
    <app-quartos [quartos]="busca.quartos"></app-quartos>
</ng-template>



<!-- PARTE DO BRASIL OPERADORA -->
<div class="modal fade bd-example-modal-lg" tabindex="-1" id="detailsModal" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                    {{"Detalhes do pacote" | translate}}
                </h5>
                <i type="button" class="btn btn-search" data-bs-dismiss="modal" class="fas fa-times"></i>
            </div>
            <div class="modal-body">
                <div class="container">

                    <div>
                        <img [src]="PacoteDetalhes?.PacoteImagens[0]?.Imagem" class="img-fluid card-img-top"
                            style="max-height: 500px; object-fit: fill" [alt]="PacoteDetalhes?.Nome" />
                    </div>
                    <div class="p-2">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation"
                                *ngFor="let inclui of PacoteDetalhes?.PacotesInclui; let i = index">
                                <button class="nav-link" [ngClass]="i == 0 ? 'active' : ''" id="tabs{{i}}"
                                    data-bs-toggle="tab" [attr.data-bs-target]="'#tab' + i" type="button"
                                    style="text-decoration: none !important;" role="tab"
                                    [attr.aria-controls]="'tab' + i" [attr.aria-selected]="i == 0 ? true : false">
                                    {{idioma == 'es' && inclui?.Titulo_Es ? inclui?.Titulo_Es :
                                    idioma == 'en' && inclui?.Titulo_En ? inclui?.Titulo_En :
                                    inclui?.Titulo
                                    }}
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content p-2 mt-2" id="myTabContent">
                            <div *ngFor="let inclui of PacoteDetalhes?.PacotesInclui; let i = index"
                                class="tab-pane fade" id="tab{{i}}" [ngClass]="i == 0 ? 'show active' : ''"
                                role="tabpanel" [attr.aria-labelledby]="'tabs' + i" [innerHTML]="idioma == 'es' && inclui?.Descritivo_Es ? inclui?.Descritivo_Es :
                      idioma == 'en' && inclui?.Descritivo_En ? inclui?.Descritivo_En :
                      inclui?.Descritivo"></div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-search" data-bs-dismiss="modal">
                        {{"Voltar" | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #contentHotelDetalhes let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
                {{"Detalhes do pacote" | translate}}
            </h5>
            <i type="button" class="btn btn-search" data-bs-dismiss="modal" class="fas fa-times"
                (click)="fecharModal()"></i>
        </div>
        <div class="modal-body">
            <div class="container" *ngFor="let trecho of busca.trechos; let i = index">
                <div class="row dateInput justify-content-start">

                    <div class="form-datepicker col-md-3" *ngIf="Pacote.PacotePeriodos.length == 0">
                        <mat-form-field class="datepicker w-100" appearance="fill">
                            <mat-label>{{ "Entrada" | translate }}</mat-label>
                            <input matInput [matDatepicker]="pickerIdaPacote" [(ngModel)]="trecho.dataIda"
                                (dateChange)="setDataIdaPacote($event.value, busca.trechos, i)" [min]="minDateModal"
                                [max]="maxDate" autocomplete="off" readonly />
                            <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                            <mat-datepicker-toggle matSuffix [for]="pickerIdaPacote"></mat-datepicker-toggle>
                            <mat-datepicker #pickerIdaPacote></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="form-datepicker col-md-3 mt-md-1" *ngIf="Pacote.PacotePeriodos.length > 0">
                        <mat-form-field class="datepicker w-100" appearance="fill">
                            <mat-label>{{"Entrada" | translate}}</mat-label>
                            <input matInput [matDatepicker]="pickerIdaPacote" [matDatepickerFilter]="myFilterData"
                                [(ngModel)]="trecho.dataIda"
                                (dateChange)="setDataIdaPacote($event.value, busca.trechos, i)" [min]="minDateModal"
                                [max]="maxDate" autocomplete="off" />
                            <mat-datepicker-toggle matSuffix [for]="pickerIdaPacote"></mat-datepicker-toggle>
                            <mat-datepicker #pickerIdaPacote></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        <span class="input-group-text" id="inputGroup-sizing-default">{{ "Noites" | translate }}</span>
                        <select class="form-control align-self-end" disabled>
                            <option value="{{busca.nrnoites}}">{{busca.nrnoites + ' Noites' | translate}}</option>
                        </select>
                    </div>

                    <div class="form-datepicker col-md-3">
                        <mat-form-field class="datepicker w-100" appearance="fill">
                            <mat-label>{{ "Saída" | translate }}</mat-label>
                            <input matInput [matDatepicker]="pickerVoltaPacote" [(ngModel)]="trecho.dataVolta"
                                autocomplete="off" disabled />
                            <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                            <mat-datepicker-toggle matSuffix [for]="pickerVoltaPacote"></mat-datepicker-toggle>
                            <mat-datepicker #pickerVoltaPacote></mat-datepicker>
                        </mat-form-field>
                    </div>

                </div>

                <div class="room">
                    <app-quartos [quartos]="busca.quartos" [modal]="false"></app-quartos>
                </div>
                <div class="input-group mt-4">
                    <div *ngIf="semAgencia" class="col-md-12 col-sm-12">
                        <div class="alert alert-danger">
                            <p>{{ "Selecione uma Agência para continuar" | translate }}</p>
                        </div>
                    </div>
                    <div *ngIf="erros?.length > 0" class="col-md-12 col-sm-12">
                        <div class="alert alert-danger" style="width: 100%">
                            <ul>
                                <li *ngFor="let mensagem of erros">{{ mensagem }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" [disabled]="desabilitaTarifa" class="btn btn-search"
            (click)="fecharModal(); BuscaPacotes(Pacote);">
            {{"Tarifar Pacote" | translate }}
        </button>
    </div>
</ng-template>